import { useMutation, useQuery } from "react-query";
import {
	getAllPromotions,
	getPromotionById,
	deletePromotionById,
	addPromotion,
	updatePromotion,
	sendPromotion,
} from "../services/promotions";

export const useGetAllPromotions = (payload) =>
	useQuery(["getAllPromotions", payload], () => getAllPromotions(payload));

export const useGetPromotionById = (id) =>
	useQuery(["getPromotionById", id], () => getPromotionById(id));

export const useAddPromotion = () =>
	useMutation("addPromotion", (payload) => addPromotion(payload));

export const useUpdatePromotion = () =>
	useMutation("updatePromotion", (payload) => updatePromotion(payload));

export const useSendPromotion = () =>
	useMutation("sendPromotion", (id) => sendPromotion(id));

export const useDeletePromotion = () =>
	useMutation("deletePromotionById", (id) => deletePromotionById(id));
